import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Checkbox, Col, Form, Row, Spin, Switch } from 'antd';
import {
	MerchantRequest,
	templeRequest,
} from '../../../../request/AuthRequest';
import { useEffect, useState } from 'react';
import useStore from '../../../../store';
import QuillEditor from '../../../../component/QuillEditor';
import FAQForm from './FAQComponent';
import CommonEditor from '../../../../component/CommonEditor';

const FormComponent = observer((props) => {
	const {
		handleChange,
		onFinish,
		id,
		form,
		setIsLiveDarshan,
		isLiveDarshan,
		cameraAllowed,
		setCameraAllowed,
		viewMode,
		propertyOverView,
		setPropertyOverView,
		propertyOptions,
		setPropertyOptions
		// testBlurEv,
		// isChecked,
		// setIsChecked,
	} = props;
	const [stateLoading, setStateLoading] = useState(true);
	const [cityLoading, setCityLoading] = useState(true);
	const {
		AUTH: { stateList, cityList, getStateList, getCityList, lookupKeyList },
		TEMPLE: { templeBasicDetail },
	} = useStore();

	useEffect(() => {
		handleChange();
	}, []);

	useEffect(() => {
		if (!isLiveDarshan) {
			form.resetFields(['liveDarshanUrl']);
			handleChange();
		}
	}, [isLiveDarshan]);

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
			onChange={handleChange}
			disabled={viewMode}
		>
			<Row gutter={24}>
				<Col span={6}>
					<InputComponent
						required
						name="templeName"
						label="Temple Name"
						placeholder="Enter Temple Name"
						onChange={handleChange}
						rules={templeRequest.templeName}
					// onBlur={() => {
					// 	if (isChecked) {
					// 		testBlurEv();
					// 	}
					// }}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="shortName"
						label="Short Name"
						placeholder="Enter Short Name"
						onChange={handleChange}
						rules={templeRequest.shortName}
					// disabled={id === 'EditForm'}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="bestTimeToVisit"
						label="Best Time to Visit"
						placeholder="Enter Best Time to Visit"
						onChange={handleChange}
						rules={templeRequest.bestTimeToVisit}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="templeWebsite"
						label="Temple Website"
						placeholder="Enter Temple Website"
						onChange={handleChange}
						rules={MerchantRequest.URL}
					/>
				</Col>
				<Col span={3}>
					<Form.Item
						required
						name="isLiveDarshan"
						label="Live Darshan"
					>
						<Switch
							value={isLiveDarshan}
							onChange={setIsLiveDarshan}
						/>
					</Form.Item>
				</Col>
				<Col span={6}>
					<InputComponent
						required={isLiveDarshan}
						name="liveDarshanUrl"
						label="Live Darshan Url"
						placeholder="Enter Live Darshan Url"
						onChange={handleChange}
						rules={
							isLiveDarshan ? MerchantRequest.isLiveDarshan : []
						}
						disabled={viewMode ? viewMode : !isLiveDarshan}
					/>
				</Col>
				<Col span={3}>
					<Form.Item name="cameraAllowed" label="Allowed Camera">
						<Switch
							value={cameraAllowed}
							onChange={setCameraAllowed}
						/>
					</Form.Item>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={true}
						name="eStateId"
						label="Select State"
						placeholder="Select State"
						onFocus={() =>
							stateLoading &&
							getStateList().then(() => setStateLoading(false))
						}
						notFoundContent={
							stateLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(stateList.length && stateList) ||
								(templeBasicDetail && [
									{
										eRegionId:
											templeBasicDetail &&
											templeBasicDetail.eStateId &&
											templeBasicDetail.eStateId,
										regionName:
											templeBasicDetail &&
											templeBasicDetail.stateName &&
											templeBasicDetail.stateName,
									},
								]),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={() => {
							form.resetFields(['eCityId']);
							setCityLoading(true);
							handleChange();
							// if (isChecked) {
							// 	testBlurEv();
							// }
						}}
						rules={MerchantRequest.state}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						// onBlur={() => {
						// 	if (isChecked) {
						// 		testBlurEv();
						// 	}
						// }}
						type="select"
						showSearch={true}
						name="eCityId"
						label="Select City"
						placeholder="Select City"
						onFocus={() =>
							cityLoading &&
							getCityList(form.getFieldValue('eStateId')).then(
								() => setCityLoading(false)
							)
						}
						notFoundContent={
							cityLoading ? (
								<Spin size="small" />
							) : (
								'No Data Found'
							)
						}
						options={{
							values:
								(cityList.length && cityList) ||
								(templeBasicDetail && [
									{
										eRegionId:
											templeBasicDetail &&
											templeBasicDetail.eCityId &&
											templeBasicDetail.eCityId,
										regionName:
											templeBasicDetail &&
											templeBasicDetail.cityName &&
											templeBasicDetail.cityName,
									},
								]),
							value_key: 'eRegionId',
							text_key: 'regionName',
						}}
						onChange={() => {
							handleChange();
							// if (isChecked) {
							// 	testBlurEv();
							// }
						}}
						disabled={
							viewMode
								? true
								: form.getFieldValue('eStateId')
									? false
									: true
						}
						rules={MerchantRequest.city}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="seoTitle"
						label="SEO Title"
						placeholder="Enter SEO Title"
						onChange={handleChange}
						rules={templeRequest.seoTitle}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						// required
						name="pinCode"
						label="Pin Code"
						placeholder="Enter Pin Code"
						onChange={handleChange}
						rules={MerchantRequest.pinCode}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type="select"
						showSearch={false}
						name="popularity"
						label="Select Popularity"
						placeholder="Select Popularity"
						options={{
							values: lookupKeyList,
							value_key: 'lookupIntValue',
							text_key: {
								key: ['lookupIntValue', ' - ', 'lookupValue'],
							},
						}}
						onChange={handleChange}
						rules={templeRequest.popularity}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						name="address"
						label="Address"
						placeholder="Enter Address"
						onChange={handleChange}
						rules={MerchantRequest.address}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type={'textarea'}
						name="howtoReach"
						label="How to Reach"
						placeholder="Enter How to Reach"
						onChange={handleChange}
						rules={templeRequest.howtoReach}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type={'textarea'}
						name="nearbyPlaces"
						label="Nearby Places"
						placeholder="Enter Nearby Places"
						onChange={handleChange}
						rules={templeRequest.nearbyPlaces}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						// required
						type={'textarea'}
						name="remarks"
						label="Remarks"
						placeholder="Enter Remarks"
						onChange={handleChange}
						rules={templeRequest.remarks}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						required
						type={'textarea'}
						name="description"
						label="Description"
						placeholder="Enter Description"
						onChange={handleChange}
						rules={templeRequest.description}
					/>
				</Col>
				<Col span={6}>
					<InputComponent
						name="ctaText"
						label="CTA Text"
						placeholder="Enter CTA Text"
						onChange={handleChange}
						rules={templeRequest.CTAText}
					/>
				</Col>
				<Col span={12}>
					<Form.Item label="FAQs">
						<FAQForm form={form} onChange={handleChange} />
					</Form.Item>
				</Col>
				<Col span={12}>
					<InputComponent
						type={'textarea'}
						name="faQsSchema"
						label="FAQs Schema"
						placeholder="FAQs Schema"
						onChange={handleChange}
						rules={templeRequest.faQsSchema}
						rows={9}
					/>
				</Col>
				{/* <Col span={24}>
					<Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
						Want to add meta data
					</Checkbox>
				</Col> */}
				{/* {isChecked && ( */}
				<>
					<Col span={8}>
						<InputComponent
							required
							name="metaTitle"
							label="Meta Title"
							placeholder="Enter Meta Title"
							onChange={handleChange}
							rules={templeRequest.metaTitle}
						/>
					</Col>
					<Col span={8}>
						<InputComponent
							required
							name="metaKeywords"
							label="Meta Keywords"
							placeholder="Enter MetaKey Words"
							onChange={handleChange}
							rules={templeRequest.metaKeywords}
						/>
					</Col>
					<Col span={8}>
						<InputComponent
							required
							type={'textarea'}
							name="metaDescription"
							label="Meta Description"
							placeholder="Enter Meta Description"
							onChange={handleChange}
							rules={templeRequest.metaDescription}
						/>
					</Col>
				</>
				{/* )} */}
				{propertyOverView && Object.keys(propertyOverView).length ?
				<Col span={24}>
					<label class="ant-form-item-required" title="Description">Peoprty Overview</label>
					{/* <QuillEditor
						value={propertyOverView}
						placeholder={'Enter Peoprty Overview'}
						height={'190px'}
						onChange={(val) => setPropertyOverView(val)}
					/> */}
						<CommonEditor
							value={propertyOverView || {}}
							onChange={(data) => {setPropertyOverView(data); handleChange()}}
						/>
				</Col>
				: null}
				{propertyOptions && Object.keys(propertyOptions).length ?
					<Col span={24}>
					<label class="ant-form-item-required mt-2" title="Description">Property Options</label>
					{/* <QuillEditor
						value={propertyOptions}
						placeholder={'Enter Property Options'}
						height={'190px'}
						onChange={(val) => setPropertyOptions(val)}
					/> */}

						<CommonEditor
							value={propertyOptions || {}}
							onChange={(data) => {setPropertyOptions(data); handleChange()}}
						/>
				</Col>
				: null}
			</Row>
		</Form>
	);
});

export default FormComponent;
